import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  lawyersListSelector,
  statesListSelector,
} from '../../redux/selectors/common-selectors';

import styles from './Lawyers.module.scss';

import { selectLawyerState } from '../../redux/actions/lawyers-actions-creator';
import BackButtonHeader from '../../components/back-button-header/BackButtonHeader';
import LawyerInfoCard from '../../components/lawyer-info-card/LawyerInfoCard';
import DropdownSelector from '../../components/dropdown-selector/DropdownSelector';

const Lawyers = () => {
  const dispatch = useDispatch();
  const lawyersList = useSelector(lawyersListSelector);
  const statesList = useSelector(statesListSelector);

  useEffect(() => {
    // did mount

    dispatch(selectLawyerState(''));

    return () => {
      // did unmount
    };
  }, [dispatch]);

  const handleSelectState = (selectedState) => {
    dispatch(selectLawyerState(selectedState));
  };

  return (
    <>
      <BackButtonHeader />
      <div className={styles.contentWrapper}>
        <div className={styles.upperLine} />
        <h1>Pro bono Lawyers</h1>
        <p>
          These lawyers have offered to help people that get in trouble. Select
          your state to find a resource close to you.
        </p>
        <div>
          <DropdownSelector
            listData={statesList}
            onSelected={handleSelectState}
          />

          {!!lawyersList &&
            lawyersList.map((lawyer) => (
              <LawyerInfoCard key={`event-${lawyer.id}`} infoData={lawyer} />
            ))}
        </div>
      </div>
    </>
  );
};

export default Lawyers;
